import React, { useEffect, useState } from 'react'
import { DonutChart, BarChart, LineChart } from '@mantine/charts'
import '../../styles/admin/dashboard.css'
import { useAuthStore } from '../../store'
import { useUserStore } from '../../store/useUserStore'
import { useNavigate } from 'react-router-dom'
import ProgressBar from '../common/ProgressStep'
import { apiRequest } from '../../utils/api'
import { modals } from '@mantine/modals'
import BaseButton from '../common/BaseButton'

const ParentsDashboardBox = () => {
  const user = useAuthStore((state) => state.user)
  const navigate = useNavigate()
  const [summaryData, setSummaryData] = useState({
    averageAnswers: 0,
    level: '',
    progress: 0,
  })
  const [wrongData, setWrongData] = useState([])
  const [wrongPercent, setWrongPercent] = useState([])
  const [wrongLineData, setWrongLineData] = useState([])
  const [hoveredDonutIndex, setHoveredDonutIndex] = useState(null)

  const chartLabels = ['First Try', 'Review 1', 'Review 2', 'Mastery']
  const improvement =
    wrongPercent.length >= 4
      ? (
          Number(wrongPercent[3].percent || 0) -
          Number(wrongPercent[0].percent || 0)
        ).toFixed(1)
      : '0.0'
        const getProgressColor = (progress) => {
    if (progress < 30) return ['#FF6B6B', '#FFA07A']
    if (progress < 70) return ['#4F6BED', '#69A7FF']
    return ['#22C55E', '#86EFAC']
  }

  const getNextMilestone = (progress) => {
    const milestones = [25, 50, 75, 100]
    return milestones.find((milestone) => progress < milestone) || 100
  }
      const isWrongReviewStep = summaryData.progress >= 100
  const nextActivityLabel = isWrongReviewStep
    ? 'Wrong Answer Review'
    : summaryData.level
      ? `${summaryData.level}`
      : 'Continue learning'
  const nextButtonLabel = isWrongReviewStep ? 'Start Review →' : 'Start Lesson →'

  const shineStyle = `
    @keyframes shine {
      0% { left: -40%; }
      100% { left: 100%; }
    }
  `

  useEffect(() => {
    console.log("user" ,user)
    if (user?.ID) {
      fetchStudentDashboard(user.ID)
    }
  }, [user?.ID])

  const fetchStudentDashboard = async (user) => {
    try {
      const res = await apiRequest('/fetchStudentDashboard', 'POST', {
        ID: user,
      })

      if (res.data) {
        console.log('res.data?', res.data)
        setSummaryData({
          averageAnswers: res.data.AVG,
          level: res.data.LEVEL,
          progress: res.data.PROGRESS,
        })

        const total = res.data.TOTAL.total_problems
        const wrongValues = res.data.WRONG

        const wrong1 = wrongValues.find((v) => v.attempt === 0)?.value || 0
        const wrong2 = wrongValues.find((v) => v.attempt === 1)?.value || 0
        const wrong3 = wrongValues.find((v) => v.attempt === 2)?.value || 0
        const wrong4 = wrongValues.find((v) => v.attempt === 3)?.value || 0

        setWrongPercent([
          { percent: (((total - wrong1) / total) * 100).toFixed(1) },
          { percent: (((total - wrong2) / total) * 100).toFixed(1) },
          { percent: (((total - wrong3) / total) * 100).toFixed(1) },
          { percent: (((total - wrong4) / total) * 100).toFixed(1) },
        ]);

        setWrongData([
          [
            { name: 'Correct', value: total - wrong1, color: '#30ACC6' },
            { name: 'Wrong (1st)', value: wrong1, color: '#F1F1F1' },
          ],
          [
            { name: 'Correct', value: total - wrong2, color: '#8F70AE' },
            { name: 'Wrong (2nd)', value: wrong2, color: '#F1F1F1' },
          ],
          [
            { name: 'Correct', value: total - wrong3, color: '#F7B52C' },
            { name: 'Wrong (3rd)', value: wrong3, color: '#F1F1F1' },
          ],
          [
            { name: 'Correct', value: total - wrong4, color: '#8DC21F' },
            { name: 'Wrong (4th)', value: wrong4, color: '#F1F1F1' },
          ],
        ])

        const lineData = (res.data.WRONG || [])
          .sort((a, b) => a.attempt - b.attempt)
          .map((item) => ({
            label: `Attempt ${item.attempt}`,
            answer: total - item.value,
          }))

        setWrongLineData(lineData)
      } else {
        throw new Error('조회 실패')
      }
    } catch (err) {}
  }

  const handleSolverPage = () => {
    if(user?.SUB === 'Y'){
      navigate('/solver')
    }else{
      showAlertModal('Subscribe to continue')
      navigate('/subscribe')
    }

  }

  const showAlertModal = (message, type = 'error') => {
    const getImageSrc = () => {
      if (type === 'success') {
        return '/assets/smart-green-monster.png'
      }
      return '/assets/rabbit-blue-monster-cry.png'
    }

    const getImageAlt = () => {
      if (type === 'success') {
        return 'Success avatar'
      }
      return 'Error avatar'
    }

    modals.open({
      children: (
        <div className="alert-container">
          <img
            src={getImageSrc()}
            alt={getImageAlt()}
            className="rabbit-monster"
          />
          <p className="alert-text">{message}</p>
          <BaseButton
            onClick={() => modals.closeAll()}
            className="alert-button"
          >
            Confirm
          </BaseButton>
        </div>
      ),
      centered: true,
      withCloseButton: false,
    })
  }

  const shouldShowStudyButton = user?.STATUS === 'U' || user?.STATUS === 'O'

  return (
    <div>
        <style>{shineStyle}</style>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1.4fr) minmax(320px, 1fr)',
          gap: '20px',
          marginBottom: '16px',
          alignItems: 'start',
        }}
      >
        <div
          style={{
            background: '#ffffff',
            border: '1px solid #E7ECF3',
            borderRadius: '24px',
            padding: '24px',
            boxShadow: '0 10px 30px rgba(13, 42, 79, 0.06)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '220px',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
              gap: '16px',
            }}
          >
            <div
              style={{
                background: '#F8FBFF',
                border: '1px solid #E6EEF8',
                borderRadius: '18px',
                padding: '18px 20px',
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: '14px',
                  color: '#7A889B',
                  fontWeight: 600,
                }}
              >
                <img src="/assets/icons/graduate.png" alt="student" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle', marginRight: 4 }} />Student
              </p>
              <p
                style={{
                  margin: '10px 0 0 0',
                  fontSize: '32px',
                  lineHeight: 1,
                  fontWeight: 800,
                  color: '#0D2A4F',
                }}
              >
                {user?.NICKNAME || '123'}
              </p>
            </div>

            <div
              style={{
                background: '#FFF9F1',
                border: '1px solid #F7E6C4',
                borderRadius: '18px',
                padding: '18px 20px',
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: '14px',
                  color: '#7A889B',
                  fontWeight: 600,
                }}
              >
                <img src="/assets/icons/book.png" alt="book" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle', marginRight: 4 }} />Current level
              </p>
              <p
                style={{
                  margin: '10px 0 0 0',
                  fontSize: '28px',
                  lineHeight: 1.1,
                  fontWeight: 800,
                  color: '#0D2A4F',
                }}
              >
                {summaryData.level}
              </p>
            </div>
          </div>

           <div
                style={{
                  marginTop: '30px',
                  padding: '18px 20px',
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, #F4F7FF, #EEF3FF)',
                  border: '1px solid #DCE6FF',
                  boxShadow: '0 10px 24px rgba(79, 107, 237, 0.10)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '16px',
                }}
          >
            <div>
              <p
                style={{
                  margin: 0,
                  fontSize: '14px',
                  color: '#5F74A8',
                  fontWeight: 700,
                  letterSpacing: '0.01em',
                }}
              >
                <img src="/assets/icons/pencil.png" alt="next step" style={{ width: 14, height: 14, objectFit: 'contain', verticalAlign: 'middle', marginRight: 4 }} />Next step
              </p>
              <p
                style={{
                  margin: '6px 0 0 0',
                  fontSize: '17px',
                  color: '#0D2A4F',
                  fontWeight: 700,
                }}
              >
                Continue learning
              </p>
            </div>

            {shouldShowStudyButton && (
            <button
              onClick={handleSolverPage}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)'
                e.currentTarget.style.boxShadow = '0 16px 30px rgba(79, 107, 237, 0.26)'
                e.currentTarget.style.filter = 'brightness(1.02)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 12px 26px rgba(79, 107, 237, 0.22)'
                e.currentTarget.style.filter = 'brightness(1)'
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = 'translateY(1px) scale(0.99)'
                e.currentTarget.style.boxShadow = '0 8px 18px rgba(79, 107, 237, 0.20)'
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)'
                e.currentTarget.style.boxShadow = '0 16px 30px rgba(79, 107, 237, 0.26)'
              }}
              style={{
                border: 'none',
                background: 'linear-gradient(135deg, #5674F4, #3E5AD7)',
                color: '#ffffff',
                borderRadius: '18px',
                padding: '18px 28px',
                fontSize: '20px',
                fontWeight: 800,
                cursor: 'pointer',
                boxShadow: '0 12px 26px rgba(79, 107, 237, 0.22)',
                whiteSpace: 'nowrap',
                minWidth: '280px',
                maxWidth: '360px',
                width: '100%',
                letterSpacing: '0.01em',
                transition: 'transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease',
                position: 'relative',
              }}
            >
              Start Lesson! →
            </button>
            )}
          </div>
        </div>

        <div
          style={{
            background: '#ffffff',
            border: '1px solid #E7ECF3',
            borderRadius: '24px',
            padding: '24px',
            boxShadow: '0 10px 30px rgba(13, 42, 79, 0.06)',
            minHeight: '220px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '18px',
          }}
        >
          <div>
            <p
              style={{
                margin: 0,
                fontSize: '14px',
                color: '#7A889B',
                fontWeight: 700,
                letterSpacing: '0.01em',
              }}
            >
              🏁 Course progress
            </p>
            <p
              style={{
                margin: '8px 0 0 0',
                fontSize: '16px',
                color: '#0D2A4F',
                fontWeight: 700,
              }}
            >
              How much of the course is completed
            </p>
          </div>

          <div style={{ marginTop: '8px' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px',
                gap: '12px',
                flexWrap: 'wrap',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '999px',
                    background: '#EEF4FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '22px',
                  }}
                >
                  <img src="/assets/icons/target.png" alt="accuracy" style={{ width: 22, height: 22, objectFit: 'contain' }} />
                </div>
                <div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: '13px',
                      color: '#7A889B',
                      fontWeight: 600,
                    }}
                  >
                    Current progress
                  </p>
                  <p
                    style={{
                      margin: '2px 0 0 0',
                      fontSize: '24px',
                      color: '#0D2A4F',
                      fontWeight: 800,
                    }}
                  >
                    {summaryData.progress}%
                  </p>
                </div>
              </div>

              <div
                style={{
                  background: '#EEF8F2',
                  color: '#1F9D55',
                  borderRadius: '999px',
                  padding: '8px 12px',
                  fontSize: '13px',
                  fontWeight: 800,
                }}
              >
                On track
              </div>
            </div>

            <div
              style={{
                width: '100%',
                height: '20px',
                borderRadius: '999px',
                background: '#E9EEF5',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  width: `${summaryData.progress}%`,
                  height: '100%',
                  borderRadius: '999px',
                  background: `linear-gradient(90deg, ${getProgressColor(summaryData.progress)[0]}, ${getProgressColor(summaryData.progress)[1]})`,
                  transition: 'width 0.6s ease',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '-40%',
                    width: '40%',
                    height: '100%',
                    background:
                      'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
                    animation: 'shine 2s infinite',
                  }}
                />
              </div>
            </div>

            <div
              style={{
                marginTop: '18px',
                padding: '16px 16px',
                minHeight: '84px',
                borderRadius: '18px',
                background: 'linear-gradient(135deg, #F8FBFF, #EEF4FF)',
                border: '1px solid #DCE8FF',
                boxShadow: '0 10px 24px rgba(79, 107, 237, 0.10)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '12px',
                flexWrap: 'wrap',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                }}
              >
                <div
                  style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '999px',
                    background: 'linear-gradient(135deg, #4F6BED, #6A8BFF)',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    boxShadow: '0 8px 18px rgba(79, 107, 237, 0.22)',
                    flexShrink: 0,
                  }}
                >
                  <img src="/assets/icons/target.png" alt="accuracy" style={{ width: 16, height: 16, objectFit: 'contain' }} />
                </div>

                <div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: '13px',
                      color: '#6F7F95',
                      fontWeight: 700,
                      letterSpacing: '0.01em',
                      textTransform: 'uppercase',
                    }}
                  >
                    Next milestone
                  </p>
                  <p
                    style={{
                      margin: '6px 0 0 0',
                      fontSize: '18px',
                      color: '#0D2A4F',
                      fontWeight: 800,
                      lineHeight: 1.2,
                    }}
                  >
                    Reach {getNextMilestone(summaryData.progress)}% progress
                  </p>
                  <p
                    style={{
                      margin: '6px 0 0 0',
                      fontSize: '13px',
                      color: '#6B7A90',
                      fontWeight: 600,
                    }}
                  >
                  </p>
                </div>
              </div>

              <div
                style={{
                  background: 'linear-gradient(135deg, #4F6BED, #6A8BFF)',
                  color: '#ffffff',
                  borderRadius: '999px',
                  padding: '10px 12px',
                  fontSize: '14px',
                  fontWeight: 800,
                  whiteSpace: 'nowrap',
                  boxShadow: '0 8px 18px rgba(79, 107, 237, 0.22)',
                }}
              >
                Keep going! <img src="/assets/icons/rocket.png" alt="rocket" style={{ width: 16, height: 16, objectFit: 'contain', verticalAlign: 'middle' }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="left-section">
        <div
          className="learning-section"
          style={{
            background: '#ffffff',
            border: '1px solid #e9eef5',
            borderRadius: '24px',
            padding: '28px',
            boxShadow: '0 10px 30px rgba(13, 42, 79, 0.06)',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: '16px',
              marginBottom: '24px',
              flexWrap: 'wrap',
            }}
          >
            <div>
              <h3 className="section-title" style={{ marginBottom: '10px' }}>
                <img src="/assets/icons/hint.png" alt="hint" style={{ width: 18, height: 18, objectFit: 'contain', verticalAlign: 'middle', marginRight: 6 }} />Improvement Through Reattempts
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '16px',
                  color: '#6B7A90',
                  lineHeight: 1.6,
                }}
              >
                Incorrect questions are saved and reattempted, so that accuracy improves over time.
              </p>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: 'linear-gradient(135deg, #E6F9F0, #D1F2E0)',
                color: '#1F9D55',
                boxShadow: '0 4px 12px rgba(31,157,85,0.15)',
                borderRadius: '999px',
                padding: '10px 14px',
                fontSize: '14px',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                marginTop: '4px',
              }}
            >
              <span style={{ fontSize: '16px' }}>↗</span>
              <span>+{improvement}% improvement</span>
            </div>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
              gap: '20px',
              alignItems: 'start',
            }}
          >
            {wrongData.map((d, i) => (
              <div
                key={i}
                onMouseEnter={() => setHoveredDonutIndex(i)}
                onMouseLeave={() => setHoveredDonutIndex(null)}
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minWidth: 0,
                  transition: 'transform 0.2s ease',
                  transform: hoveredDonutIndex === i ? 'scale(1.06)' : 'scale(1)',
                }}
              >
                {hoveredDonutIndex === i && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '-16px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: '#ffffff',
                      border: '1px solid #E3EAF3',
                      boxShadow: '0 8px 20px rgba(13, 42, 79, 0.12)',
                      borderRadius: '12px',
                      padding: '10px 14px',
                      minWidth: '150px',
                      zIndex: 20,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '12px',
                        fontSize: '13px',
                        fontWeight: 700,
                        color: '#0D2A4F',
                      }}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                          style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '999px',
                            background: d?.[0]?.color || '#30ACC6',
                            display: 'inline-block',
                          }}
                        />
                        Correct
                      </span>
                      <span>{d?.[0]?.value ?? 0}</span>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '12px',
                        fontSize: '13px',
                        fontWeight: 700,
                        color: '#0D2A4F',
                        marginTop: '8px',
                      }}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                          style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '999px',
                            background: d?.[1]?.color || '#F1F1F1',
                            display: 'inline-block',
                            border: '1px solid #D9E2EF',
                          }}
                        />
                        {d?.[1]?.name || 'Wrong'}
                      </span>
                      <span>{d?.[1]?.value ?? 0}</span>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '180px',
                    position: 'relative',
                  }}
                >
                  <DonutChart
                    size={150}
                    thickness={28}
                    chartLabel=""
                    data={d}
                    withTooltip={false}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      pointerEvents: 'none',
                      lineHeight: 1.1,
                    }}
                  >
                    <span
                      style={{
                        fontSize: '26px',
                        fontWeight: 800,
                        color: '#0D2A4F',
                        transition: 'transform 0.2s ease',
                        transform: hoveredDonutIndex === i ? 'scale(1.1)' : 'scale(1)',
                      }}
                    >
                      {wrongPercent[i]?.percent || '0.0'}
                    </span>
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        color: '#7A889B',
                        marginTop: '4px',
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>

                <p
                  style={{
                    margin: '6px 0 0 0',
                    fontSize: '15px',
                    fontWeight: 700,
                    color: '#0D2A4F',
                  }}
                >
                  <span
                    style={{
                    color: i === 3 ? '#1F9D55' : '#0D2A4F',
                    fontWeight: i === 3 ? 800 : 700,
                  }}
                  >
                  {chartLabels[i]}
                  </span>
                </p>

                {i < wrongData.length - 1 && (
                  <div
                    style={{
                      position: 'absolute',
                      right: '-10px',
                      top: '48%',
                      transform: 'translateY(-50%)',
                      width: '34px',
                      height: '34px',
                      borderRadius: '999px',
                      background: '#F4F7FB',
                      border: '1px solid #E3EAF3',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#8B9AB0',
                      fontSize: '16px',
                      fontWeight: 700,
                      zIndex: 2,
                    }}
                  >
                    →
                  </div>
                )}
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: '28px',
              padding: '18px 20px',
              background: 'linear-gradient(135deg, #F3F7FF, #EEF4FF)',
              border: '1px solid #D9E5FF',
              borderLeft: '6px solid #4F6BED',
              borderRadius: '18px',
              boxShadow: '0 8px 20px rgba(79, 107, 237, 0.08)',
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: 800,
                color: '#173A72',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span style={{ fontSize: '18px' }}>📈</span>
              Learning Progress
            </p>
            <p
              style={{
                margin: '8px 0 0 0',
                fontSize: '16px',
                lineHeight: 1.7,
                color: '#5F74A8',
              }}
            >
              This reflects improvement through repeated practice, not just scores.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ParentsDashboardBox
